export default {
    title: 'Fade in and out',
    all: 'Fade all trend in or out'
}
